export default class LiveChatParticipant {
  readonly id: number
  readonly name: string
  readonly avatar: string


  constructor(data: { [key: string]: any }) {
    this.id = data.id
    this.name = data.name
    this.avatar = data.avatar
  }
}
